

export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      width: 50,
      slot: 'index',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '组名',
    },
    {
      key: 'province',
      dataIndex: 'province',
      title: '省份',
      width:'300px'
    },
    {
      key: 'level',
      dataIndex: 'level',
      title: '申报等级',
    },
    {
      key: 'indicator',
      dataIndex: 'indicator',
      title: '评估指标',
    },
    {
      key: 'expertnum',
      dataIndex: 'expertnum',
      title: '专家人数',
    },
    {
      key: 'operate1',
      dataIndex: 'operate1',
      title: '专家分配',
      width: 100,
      slot: 'operate1',
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '编辑',
      width: 100,
      slot: 'operate',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
